import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { brandSelector } from '../redux/reducers/app/params';

export const useViewConfig = (config) => {
  const brand = useSelector(brandSelector);
  return useMemo(() => config[brand] || config['default'], [config, brand]);
};
